"use client"

import UnderlineLink from "@modules/common/components/interactive-link"
import { useFrontendPreferences } from "@lib/frontend-preferences"

const AccountSupport = () => {
  const { locale, t } = useFrontendPreferences()

  return (
    <div
      className="sahil-account-support flex flex-col small:flex-row items-end justify-between small:border-t py-12 gap-8"
      dir={locale === "fa" ? "rtl" : "ltr"}
    >
      <div>
        <h3 className="text-xl-semi mb-4">{t.account.supportTitle}</h3>
        <span className="txt-medium">{t.account.supportBody}</span>
      </div>
      <div>
        <UnderlineLink href="/customer-service">
          {t.account.customerService}
        </UnderlineLink>
      </div>
    </div>
  )
}

export default AccountSupport
